(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('react'), require('prop-types')) :
    typeof define === 'function' && define.amd ? define(['exports', 'react', 'prop-types'], factory) :
    (global = typeof globalThis !== 'undefined' ? globalThis : global || self, factory((global["dist/index"] = global["dist/index"] || {}, global["dist/index"].js = {}), global.React, global.PropTypes));
})(this, (function (exports, React, PropTypes) { 'use strict';

    function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

    var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
    var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);

    var _assign = function __assign() {
      _assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
      };
      return _assign.apply(this, arguments);
    };
    function __rest(s, e) {
      var t = {};
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
      if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
        if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
      }
      return t;
    }

    function styleInject(css, ref) {
      if (ref === void 0) ref = {};
      var insertAt = ref.insertAt;
      if (!css || typeof document === 'undefined') {
        return;
      }
      var head = document.head || document.getElementsByTagName('head')[0];
      var style = document.createElement('style');
      style.type = 'text/css';
      if (insertAt === 'top') {
        if (head.firstChild) {
          head.insertBefore(style, head.firstChild);
        } else {
          head.appendChild(style);
        }
      } else {
        head.appendChild(style);
      }
      if (style.styleSheet) {
        style.styleSheet.cssText = css;
      } else {
        style.appendChild(document.createTextNode(css));
      }
    }

    var css_248z$1 = "/* Consolidation of frequently used colours throughout the repo */\n.primary_button {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #ffffff;\n  background: #051d33;\n  border: 1px solid transparent;\n}\n.primary_button span {\n  text-align: center;\n}\n.primary_button[disabled] {\n  background: #eeeeee;\n  border: 1px solid #c3c3c3;\n  color: #6b6b6b !important;\n  pointer-events: none;\n}\n.primary_button:hover {\n  background: #024055;\n  border: 1px solid #051d33;\n}\n.primary_button:focus {\n  background: #024055;\n  border: 1px solid #051d33;\n}\n.primary_button:active {\n  border: 1px solid #051d33;\n}\n.primary_button .icon {\n  padding-right: 10px;\n}\n\n.primary_button_outline {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #051d33;\n  background: #ffffff;\n  border: 1px solid #051d33;\n}\n.primary_button_outline span {\n  text-align: center;\n}\n.primary_button_outline[disabled] {\n  background: #eeeeee;\n  border: 1px solid #c3c3c3;\n  color: #6b6b6b !important;\n  pointer-events: none;\n}\n.primary_button_outline:hover {\n  background: #f3fafd;\n  border: 1px solid #17a2b8;\n}\n.primary_button_outline:focus {\n  border: 1px solid #6dc7be;\n}\n.primary_button_outline:active {\n  border: 1px solid #051d33;\n  color: #051d33;\n}\n.primary_button_outline .icon {\n  padding-right: 10px;\n}\n\n.primary_button_outline_danger {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #ab1212;\n  background: #ffffff;\n  border: 1px solid #ab1212;\n}\n.primary_button_outline_danger span {\n  text-align: center;\n}\n.primary_button_outline_danger[disabled] {\n  background: #eeeeee;\n  border: 1px solid #c3c3c3;\n  color: #6b6b6b !important;\n  pointer-events: none;\n}\n.primary_button_outline_danger:hover {\n  background: #f3fafd;\n  border: 1px solid #dc3545;\n  color: #dc3545 !important;\n}\n.primary_button_outline_danger:focus {\n  border: 1px solid #dc3545;\n  color: #dc3545 !important;\n}\n.primary_button_outline_danger:active {\n  border: 1px solid #051d33;\n}\n.primary_button_outline_danger .icon {\n  padding-right: 10px;\n}";
    styleInject(css_248z$1);

    var PrimaryButton = function (_a) {
        var style = _a.style, _b = _a.clickHandler, clickHandler = _b === void 0 ? function () { return null; } : _b, isDisabled = _a.isDisabled, children = _a.children, title = _a.title, type = _a.type, variant = _a.variant, _c = _a.delay, delay = _c === void 0 ? 1000 : _c, ariaLabel = _a.ariaLabel, buttonProps = __rest(_a, ["style", "clickHandler", "isDisabled", "children", "title", "type", "variant", "delay", "ariaLabel"]);
        var _d = React.useState(false), isClicked = _d[0], setIsClicked = _d[1];
        React.useEffect(function () {
            var timer;
            if (isClicked) {
                timer = setTimeout(function () {
                    setIsClicked(false);
                }, delay);
            }
            return function () { return clearTimeout(timer); };
        }, [isClicked]);
        var class_name = variant === ''
            ? 'primary_button'
            : variant === 'outline'
                ? 'primary_button_outline'
                : 'primary_button_outline_danger';
        var handleClick = function () {
            if (!isClicked) {
                setIsClicked(true);
                clickHandler();
            }
        };
        return (
        // eslint-disable-next-line react/button-has-type
        React__default["default"].createElement("button", _assign({ "data-testid": 'primary_button', "aria-label": type, type: type, className: class_name, style: style, onClick: handleClick, disabled: isDisabled, title: ariaLabel }, buttonProps),
            children && React__default["default"].createElement("span", { className: 'icon' }, children),
            " ",
            React__default["default"].createElement("span", null, title),
            ' '));
    };
    PrimaryButton.propTypes = {
        style: PropTypes__default["default"].object,
        type: PropTypes__default["default"].oneOf(['button', 'submit', 'reset']),
        clickHandler: PropTypes__default["default"].func,
        title: PropTypes__default["default"].any.isRequired,
        isDisabled: PropTypes__default["default"].bool,
        children: PropTypes__default["default"].any,
        variant: PropTypes__default["default"].oneOf(['', 'outline', 'danger']),
        delay: PropTypes__default["default"].number,
        ariaLabel: PropTypes__default["default"].string,
    };
    PrimaryButton.defaultProps = {
        style: {},
        type: 'button',
        clickHandler: function () { return null; },
        isDisabled: false,
        children: '',
        variant: '',
        delay: 1000,
        ariaLabel: '',
    };

    var css_248z = "/* Consolidation of frequently used colours throughout the repo */\n.secondary_button {\n  padding: 0.5em 1em;\n  cursor: pointer;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  opacity: 1;\n  width: 100%;\n  min-width: 4rem;\n  border-radius: 0.25rem;\n  color: #051d33;\n  background: #ffffff;\n  border: 1px solid #051d33;\n}\n.secondary_button span {\n  text-align: center;\n}\n.secondary_button[disabled] {\n  background: #eeeeee;\n  border: 1px solid #c3c3c3;\n  color: #6b6b6b !important;\n  pointer-events: none;\n}\n.secondary_button .icon {\n  padding-right: 10px;\n}";
    styleInject(css_248z);

    var SecondaryButton = function (_a) {
        var _b = _a.clickHandler, clickHandler = _b === void 0 ? function () { return null; } : _b, isDisabled = _a.isDisabled, children = _a.children, title = _a.title, type = _a.type, style = _a.style, _c = _a.delay, delay = _c === void 0 ? 1000 : _c;
        var _d = React.useState(false), isClicked = _d[0], setIsClicked = _d[1];
        React.useEffect(function () {
            var timer;
            if (isClicked) {
                timer = setTimeout(function () {
                    setIsClicked(false);
                }, delay);
            }
            return function () { return clearTimeout(timer); };
        }, [isClicked]);
        var handleClick = function () {
            if (!isClicked) {
                setIsClicked(true);
                clickHandler();
            }
        };
        return (
        // eslint-disable-next-line react/button-has-type
        React__default["default"].createElement("button", { type: type, className: 'secondary_button', style: style, onClick: handleClick, disabled: isDisabled || false },
            children && React__default["default"].createElement("span", { className: 'icon' }, children),
            " ",
            React__default["default"].createElement("span", null, title),
            ' '));
    };
    SecondaryButton.propTypes = {
        style: PropTypes__default["default"].object,
        type: PropTypes__default["default"].oneOf(['button', 'submit', 'reset']),
        clickHandler: PropTypes__default["default"].func,
        title: PropTypes__default["default"].oneOfType([PropTypes__default["default"].object, PropTypes__default["default"].string]).isRequired,
        isDisabled: PropTypes__default["default"].bool,
        delay: PropTypes__default["default"].number,
        children: PropTypes__default["default"].any,
    };
    SecondaryButton.defaultProps = {
        style: {},
        type: 'button',
        clickHandler: function () { return null; },
        isDisabled: false,
        delay: 1000,
        children: '',
    };

    exports.PrimaryButton = PrimaryButton;
    exports.SecondaryButton = SecondaryButton;

    Object.defineProperty(exports, '__esModule', { value: true });

}));
